import React from 'react';
import {ServiceBase} from '../ServiceBase';
import {ICheckboxData, IGamePopupService} from './game-popup.service.interface';
import {GamePopupComponent} from "../../components/game-popup/game-popup.component";
import {GamesMap} from "../games/games.service.interface";
import {Check} from "@sparkware/app-utils";
import {GameInfo} from "../games/game-info";
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";

export class GamePopupService extends ServiceBase implements IGamePopupService {

    private get _gameMap(): GamesMap {
        return this.services.games.gamesMap;
    }

    private async openPopup(params: {
        popupTitleText: string,
        gameInfo: GameInfo,
        subTitleText: string,
        descriptionText: string,
        menuItems: MenuItemKey[],
        onCloseHandler?: () => void,
        onClosedByXButton?: () => void,
        onClickNotNowButton?: () => void
        onClickPlay?: () => void,
        checkboxData?: ICheckboxData,
        useSquareIcons?: boolean
    }) {
        this.services.dialog.showModal(dialogHandler =>
            <GamePopupComponent
                dialogHandler={dialogHandler}
                gameInfo={params.gameInfo}
                subTitle={params.subTitleText}
                description={params.descriptionText}
                menuItems={params.menuItems}
                onClickNotNowButton={params.onClickNotNowButton}
                onClickPlay={params.onClickPlay}
                checkboxData={params.checkboxData}
            />, {
                title: params.popupTitleText,
                forceTransparentBackground: true,
                disableFullscreenMobile: true,
                forceCentralization: true,
                mobileCenterHeader: true,
                isHighPriority:  true,
                onClosedByXButton: params.onClosedByXButton,
                onClosed: params.onCloseHandler,
                shouldBeClosedOnlyByUser: true,
                noDefaultContentPadding: true
            }
        );
    }

    async showSuggestedGame(gameType: number, title: string, subTitle: string, onCloseHandler?: () => void, onClosedByXButton?: () => void, onClickNotNowButton?: () => void, onClickPlay?: () => void, checkboxData?: ICheckboxData, useSquareIcons?: boolean): Promise<void> {
        let gameInfo: GameInfo;

        if(gameType) {
            if (Check.isEmpty(this._gameMap)) {
                gameInfo = await this.services.games.getGameInfo(gameType);
            } else {
                gameInfo = this._gameMap[gameType];
            }
        }

        this.openPopup({
            popupTitleText: title,
            subTitleText: subTitle,
            descriptionText: "",
            gameInfo: gameInfo,
            menuItems: null,
            onCloseHandler: () => {
                onCloseHandler && onCloseHandler();
            },
            onClickNotNowButton: () => {
                onClickNotNowButton && onClickNotNowButton();
            },
            onClickPlay: () => {
                onClickPlay && onClickPlay();
            },
            checkboxData: checkboxData,
            onClosedByXButton: onClosedByXButton,
            useSquareIcons: useSquareIcons
        });
    }
}
